import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import '../button.css';
import PremiumPageHeader from './PremiumPageHeader';

function ListPageFloatingControls({
    formLink,
    addNewLabel = 'Add New',
    onOpenSettings,
    onExportCSV,
    onExportExcel,
    onExportPDF,
    onExportImage,
    homeLink = '/Home',
    reportListLink,
}) {
    const bottomMargin = '30px';
    const [exportOpen, setExportOpen] = useState(false);
    const hasExportActions = Boolean(onExportCSV || onExportExcel || onExportPDF || onExportImage);

    const handleExportClick = () => {
        setExportOpen((open) => !open);
    };

    return (
        <div className="floating-button-bar list-page-floating-bar">
            <div className="social-btn">
                <ul className="text-right" style={{ flexDirection: 'column' }}>
                    {onOpenSettings ? (
                        <li className="text-center" style={{ marginBottom: bottomMargin }} title="GENERAL SETTINGS">
                            <button
                                type="button"
                                className="google"
                                style={{ borderColor: 'transparent' }}
                                onClick={onOpenSettings}
                            >
                                <i className="fa fa-wrench" />
                                <i className="fa fa-wrench" />
                            </button>
                        </li>
                    ) : null}
                    {formLink ? (
                        <li className="text-center" style={{ marginBottom: bottomMargin }} title={addNewLabel.toUpperCase()}>
                            <Link to={formLink} className="google">
                                <i className="fa fa-plus" />
                                <i className="fa fa-plus" />
                            </Link>
                        </li>
                    ) : null}
                    {hasExportActions ? (
                    <li
                        className="text-center list-page-export-wrap"
                        style={{ marginBottom: bottomMargin }}
                        title="EXPORT"
                    >
                        <button
                            type="button"
                            className="google"
                            style={{ borderColor: 'transparent' }}
                            onClick={handleExportClick}
                        >
                            <i className="fa fa-floppy-o" />
                            <i className="fa fa-floppy-o" />
                        </button>
                        {exportOpen ? (
                            <div className="list-page-export-menu">
                                {onExportExcel ? (
                                    <button type="button" onClick={() => { onExportExcel(); setExportOpen(false); }}>
                                        Excel
                                    </button>
                                ) : null}
                                {onExportCSV ? (
                                    <button type="button" onClick={() => { onExportCSV(); setExportOpen(false); }}>
                                        CSV
                                    </button>
                                ) : null}
                                {onExportPDF ? (
                                    <button type="button" onClick={() => { onExportPDF(); setExportOpen(false); }}>
                                        PDF
                                    </button>
                                ) : null}
                                {onExportImage ? (
                                    <button type="button" onClick={() => { onExportImage(); setExportOpen(false); }}>
                                        Image
                                    </button>
                                ) : null}
                            </div>
                        ) : null}
                    </li>
                    ) : null}
                    {reportListLink ? (
                        <li className="text-center" style={{ marginBottom: bottomMargin }} title="REPORTS">
                            <Link to={reportListLink} className="facebook">
                                <i className="fa fa-eye" />
                                <i className="fa fa-eye" />
                            </Link>
                        </li>
                    ) : null}
                    <li className="text-center" title="HOME">
                        <Link to={homeLink} className="twitter">
                            <i className="fa fa-home" />
                            <i className="fa fa-home" />
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}

function ListPageLayout({
    moduleLabel,
    title,
    subtitle,
    recordCount = 0,
    recordLabel = 'records',
    summaryStats = [],
    hideRecordSummary = false,
    searchText = '',
    onSearchChange,
    searchPlaceholder = 'Search invoice no, customer, site, amount...',
    toolbarFilters = null,
    settingsSummary = '',
    onOpenSettings,
    children,
    formLink,
    addNewLabel = 'Add New',
    onExportCSV,
    onExportExcel,
    onExportPDF,
    onExportImage,
    homeLink = '/Home',
    modeLabel = 'VIEW MODE',
    toolbarVariant = 'default',
    reportListLink,
}) {
    const recordLabelText = recordCount === 1 ? recordLabel.replace(/s$/, '') : recordLabel;

    return (
        <div className="list-page">
            <ListPageFloatingControls
                formLink={formLink}
                addNewLabel={addNewLabel}
                onOpenSettings={onOpenSettings}
                onExportCSV={onExportCSV}
                onExportExcel={onExportExcel}
                onExportPDF={onExportPDF}
                onExportImage={onExportImage}
                homeLink={homeLink}
                reportListLink={reportListLink}
            />
            <div className="premium-page-header-wrap">
                <PremiumPageHeader
                    module={moduleLabel}
                    title={title}
                    subtitle={subtitle}
                    modeLabel={modeLabel}
                />
            </div>

            <div className="list-page-panel">
                <div className={`list-page-toolbar${toolbarVariant === 'stacked' ? ' is-stacked' : ''}`}>
                    {onSearchChange ? (
                        <div className="list-page-search list-page-search-prominent">
                            <i className="fa fa-search list-page-toolbar-icon" aria-hidden="true" />
                            <input
                                type="search"
                                className="list-page-search-input"
                                placeholder={searchPlaceholder}
                                value={searchText}
                                onChange={(event) => onSearchChange(event.target.value)}
                            />
                        </div>
                    ) : null}
                    {toolbarFilters ? (
                        <div className={`list-page-toolbar-filters${toolbarVariant === 'stacked' ? ' is-stacked report-toolbar-filters-panel form-control-panel' : ''}`}>
                            {toolbarFilters}
                        </div>
                    ) : null}
                    <div className="list-page-toolbar-actions">
                        {formLink ? (
                            <Link to={formLink} className="list-page-add-new-btn">
                                <i className="fa fa-plus" aria-hidden="true" />
                                {addNewLabel}
                            </Link>
                        ) : null}
                        {onOpenSettings ? (
                            <button
                                type="button"
                                className="list-page-filter-toggle"
                                onClick={onOpenSettings}
                                title="General settings for sales"
                            >
                                <i className="fa fa-cog list-page-toolbar-icon" aria-hidden="true" />
                            </button>
                        ) : null}
                    </div>
                </div>

                {settingsSummary ? (
                    <div className="list-page-settings-summary">{settingsSummary}</div>
                ) : null}

                {!hideRecordSummary ? (
                    <div className="list-page-summary-bar">
                        <div className="list-page-summary-primary">
                            <span className="list-page-summary-label">FILTERED VIEW</span>
                            <span className="list-page-summary-count">
                                {recordCount} {recordLabelText}
                            </span>
                        </div>
                        <div className="list-page-summary-metrics">
                            {summaryStats.map((stat) => (
                                <div className="list-page-metric-card" key={stat.label}>
                                    <span className="list-page-metric-label">{stat.label}</span>
                                    <span className={`list-page-metric-value${stat.accent ? ` is-${stat.accent}` : ''}`}>
                                        {stat.value}
                                    </span>
                                    {stat.subValue ? (
                                        <span className="list-page-metric-subvalue">{stat.subValue}</span>
                                    ) : null}
                                </div>
                            ))}
                        </div>
                    </div>
                ) : null}

                <div className="list-page-table-wrap">{children}</div>
            </div>
        </div>
    );
}

export { ListPageFloatingControls };
export default ListPageLayout;
